import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import components from '../../components';
import ProviderDetailsTable from '../../components/Table/ProviderDetailsTable';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';

const ProviderDataConsumer = () => {
  const[data,setdata]=useState([])
  const[searchData,setsearchData]=useState("")
  const [updateCount,setupdateCount]=useState("")
   const {id}=useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const getAllProviderDataByAdmin=async()=>{
      try {
        console.log("🚀 ~ getAllProviderDataByAdmin ~ Fetching fund subscribers data...")

        let data = [];
        const currentProviderId = localStorage.getItem('id');
        console.log("🚀 ~ Current provider ID:", currentProviderId);

        // Primary endpoint: Get all buyers (purchases) - this contains fund subscriber purchase data
        try {
          console.log("🚀 ~ Trying /buyer/getAllBuyers...")
          const buyersResponse = await ApiCall.SECURE_API.get('/buyer/getAllBuyers');
          
          if (buyersResponse.data.success && buyersResponse.data.data && buyersResponse.data.data.length > 0) {
            console.log(`🚀 ~ Found ${buyersResponse.data.data.length} purchase records`)
            
            // Process the buyer/purchase data
            const purchases = buyersResponse.data.data;
            
            // Group purchases by BuyerConsumer to aggregate data per subscriber
            const subscriberMap = new Map();
            
            purchases.forEach((purchase, idx) => {
              // Extract buyer ID from BuyerConsumer (Fund Subscriber)
              const buyerId = purchase?.BuyerConsumer?._id || 
                             (typeof purchase?.BuyerConsumer === 'object' && purchase.BuyerConsumer.toString ? purchase.BuyerConsumer.toString() : purchase?.BuyerConsumer) ||
                             purchase?.BuyerProvider?._id || 
                             purchase?.BuyerProvider;
              
              if (!buyerId) {
                console.warn('⚠️ Purchase missing buyer ID:', purchase);
                return;
              }
              
              const buyerIdStr = typeof buyerId === 'object' ? buyerId.toString() : String(buyerId);
              
              // Get buyer details - MUST use BuyerConsumer for Fund Subscribers
              let buyer = purchase?.BuyerConsumer;
              
              // Debug first purchase to see what we're getting
              if (idx === 0) {
                console.log('🔍 First purchase from API:', {
                  hasBuyerConsumer: !!purchase.BuyerConsumer,
                  BuyerConsumerType: typeof purchase.BuyerConsumer,
                  BuyerConsumerKeys: purchase.BuyerConsumer ? Object.keys(purchase.BuyerConsumer) : [],
                  firstName: purchase.BuyerConsumer?.firstName,
                  lastName: purchase.BuyerConsumer?.lastName,
                  email: purchase.BuyerConsumer?.email,
                  walletAddress: purchase.BuyerConsumer?.walletAddress
                });
              }
              
              // Verify BuyerConsumer is populated with fund subscriber data
              if (buyer && (buyer.firstName || buyer.lastName || buyer.email)) {
                console.log('✅ Found populated BuyerConsumer (Fund Subscriber):', {
                  firstName: buyer.firstName,
                  lastName: buyer.lastName,
                  email: buyer.email,
                  walletAddress: buyer.walletAddress
                });
              } else {
                console.warn('⚠️ BuyerConsumer not properly populated:', {
                  buyer: buyer,
                  purchaseKeys: Object.keys(purchase || {})
                });
              }
              
              const purchaseDate = purchase?.purchaseDate || purchase?.createdAt || purchase?.dataUnit?.createdAt;
              
              if (subscriberMap.has(buyerIdStr)) {
                // Aggregate data for existing subscriber
                const existing = subscriberMap.get(buyerIdStr);
                existing.totalCount += 1;
                
                // Update BuyerConsumer if this purchase has a populated buyer and existing doesn't
                if (buyer && (buyer.firstName || buyer.lastName || buyer.institutionName)) {
                  if (!existing.BuyerConsumer || (!existing.BuyerConsumer.firstName && !existing.BuyerConsumer.institutionName)) {
                    console.log('✅ Updating BuyerConsumer for existing subscriber with populated buyer');
                    existing.BuyerConsumer = buyer;
                  }
                }
                
                // Update last transaction date (most recent purchase)
                if (purchaseDate && (!existing.lastTransactionDate || new Date(purchaseDate) > new Date(existing.lastTransactionDate))) {
                  existing.lastTransactionDate = purchaseDate;
                }
                
                // Keep the earliest purchase date as "joined date" (first purchase)
                if (purchaseDate && (!existing.purchaseDate || new Date(purchaseDate) < new Date(existing.purchaseDate))) {
                  existing.purchaseDate = purchaseDate;
                }
                
                // Aggregate total purchase price (sum all purchases)
                const currentPriceWei = purchase?.priceWei || purchase?.totalWei || '0';
                const existingPriceWei = existing.priceWei || '0';
                try {
                  // Try using BigInt for very large numbers (wei values can be huge)
                  existing.priceWei = (BigInt(existingPriceWei) + BigInt(currentPriceWei)).toString();
                } catch (e) {
                  // Fallback: convert to numbers and add (may lose precision for very large values)
                  existing.priceWei = (Number(existingPriceWei) + Number(currentPriceWei)).toString();
                }
                
                // Keep the most recent purchase's WalletAddress, selectedLevel, etc. if needed
                // (or aggregate as needed - for now keep first one for consistency)
              } else {
                // Create new subscriber entry - this is their first purchase
                // IMPORTANT: Only use fund subscriber data, NOT provider data
                let buyerConsumer = null;
                
                if (buyer && (buyer.firstName || buyer.lastName || buyer.email)) {
                  // Use the populated fund subscriber data
                  // Prefer WalletAddress from purchase, then buyer's walletAddress
                  const walletAddr = purchase?.WalletAddress || 
                                   (Array.isArray(buyer.walletAddress) && buyer.walletAddress.length > 0 ? buyer.walletAddress[0] : buyer.walletAddress) ||
                                   '';
                  buyerConsumer = {
                    _id: buyer._id || buyerIdStr,
                    firstName: buyer.firstName || '',
                    lastName: buyer.lastName || '',
                    email: buyer.email || '',
                    walletAddress: Array.isArray(walletAddr) ? walletAddr : [walletAddr],
                    status: buyer.status,
                    isVerified: buyer.isVerified,
                    totalPurchased: buyer.totalPurchased || purchase?.ticketsPurchased || 0,
                    createdAt: buyer.createdAt || purchaseDate || new Date().toISOString()
                  };
                  console.log('✅ Created buyerConsumer from populated fund subscriber:', buyerConsumer);
                } else {
                  // Fallback: Create minimal subscriber object (shouldn't happen if API populates correctly)
                  console.warn('⚠️ No populated buyer found, creating minimal buyerConsumer');
                  buyerConsumer = {
                    _id: buyerIdStr,
                    firstName: '',  // Don't use provider/fund name
                    lastName: '',   // Don't use "Subscriber"
                    email: '',      // Don't use provider email
                    walletAddress: [purchase?.WalletAddress || ''],
                    status: buyer?.status ?? buyer?.isVerified ?? false,
                    isVerified: buyer?.isVerified ?? false,
                    totalPurchased: purchase?.ticketsPurchased || 0,
                    createdAt: purchaseDate || new Date().toISOString()
                  };
                }
                
                console.log('🔍 Setting BuyerConsumer for new subscriber:', {
                  buyerIdStr: buyerIdStr,
                  hasFirstName: !!buyerConsumer.firstName,
                  firstName: buyerConsumer.firstName,
                  lastName: buyerConsumer.lastName,
                  isPopulated: !!(buyerConsumer.firstName || buyerConsumer.lastName || buyerConsumer.institutionName)
                });
                
                subscriberMap.set(buyerIdStr, {
                  _id: purchase._id || `subscriber_${buyerIdStr}`,
                  BuyerConsumer: buyerConsumer,
                  BuyerProvider: purchase?.BuyerProvider || purchase?.buyerProvider,
                  dataUnit: purchase?.dataUnit,
                  selectedLevel: purchase?.selectedLevel,
                  fundUnitName: purchase?.fundUnitName || purchase?.fundName || purchase?.dataUnit?.fundUnitName,
                  fundName: purchase?.fundName || purchase?.dataUnit?.name,
                  institutionName: purchase?.institutionName || purchase?.dataUnit?.provider?.institutionName,
                  institutionCode: purchase?.institutionCode || purchase?.dataUnit?.provider?.institutionCode,
                  ticketsPurchased: purchase?.ticketsPurchased || 1,
                  priceWei: purchase?.priceWei || purchase?.totalWei || purchase?.dataUnit?.price || '0',
                  totalWei: purchase?.totalWei || purchase?.priceWei || '0',
                  transactionHash: purchase?.transactionHash,
                  WalletAddress: purchase?.WalletAddress || purchase?.dataUnit?.providerWalletAddress || '',
                  purchaseDate: purchaseDate || new Date().toISOString(), // First purchase date (Joined Fund on)
                  lastTransactionDate: purchaseDate || new Date().toISOString(), // Last purchase date
                  totalCount: 1
                });
              }
            });
            
            // Convert map to array
            data = Array.from(subscriberMap.values());
            
            console.log(`🚀 ~ Processed ${data.length} unique fund subscribers from purchases`)
            if (data.length > 0) {
              console.log(`🚀 ~ First subscriber data:`, {
                _id: data[0]._id,
                BuyerConsumer: data[0].BuyerConsumer ? {
                  _id: data[0].BuyerConsumer._id,
                  firstName: data[0].BuyerConsumer.firstName,
                  lastName: data[0].BuyerConsumer.lastName,
                  email: data[0].BuyerConsumer.email,
                  hasFirstName: !!data[0].BuyerConsumer.firstName,
                  hasLastName: !!data[0].BuyerConsumer.lastName
                } : null,
                WalletAddress: data[0].WalletAddress,
                purchaseDate: data[0].purchaseDate
              });
            }
            
          } else {
            console.log("🚀 ~ No purchase data from /buyer/getAllBuyers")
          }
        } catch (error) {
          console.error("🚀 ~ Error fetching from /buyer/getAllBuyers:", error.message);
        }

        // Fallback: If no purchase data, try getting fund subscribers directly
        if (data.length === 0) {
          try {
            console.log("🚀 ~ Trying /admin/getAllFundSubscribers as fallback...")
            const response = await ApiCall.SECURE_API.get('/admin/getAllFundSubscribers');
            
            if (response.data.success && response.data.data && response.data.data.length > 0) {
              // Transform fund subscriber records to match expected structure
              data = response.data.data.map((subscriber, index) => ({
                _id: subscriber._id || `subscriber_${index}`,
                BuyerConsumer: {
                  _id: subscriber._id,
                  firstName: subscriber.firstName || subscriber.name?.split(' ')[0] || 'Fund',
                  lastName: subscriber.lastName || subscriber.name?.split(' ').slice(1).join(' ') || 'Subscriber',
                  email: subscriber.email || '',
                  walletAddress: subscriber.walletAddress || [],
                  status: subscriber.status ?? false,
                  totalPurchased: 0,
                  createdAt: subscriber.createdAt || new Date().toISOString()
                },
                totalCount: 0,
                lastTransactionDate: null
              }));
              
              console.log(`🚀 ~ Found ${data.length} fund subscribers from /admin/getAllFundSubscribers`)
            }
          } catch (error) {
            console.error("🚀 ~ Error fetching from /admin/getAllFundSubscribers:", error.message);
          }
        }

        // Show final result
        if (data.length === 0) {
          console.log("⚠️ No fund subscriber data available - showing empty table")
        } else {
          console.log(`✅ Successfully loaded ${data.length} fund subscribers`)
          console.log("🚀 ~ First subscriber:", data[0])
          console.log("🚀 ~ First subscriber BuyerConsumer ID:", data[0]?.BuyerConsumer?._id)
        }

        setdata(data);
      } catch (error) {
        console.error("🚀 ~ getAllProviderDataByAdmin ~ error:", error)
        setdata([])
      }
    }
    console.log('location', location)
    useEffect(()=>{
  
      getAllProviderDataByAdmin()
    },[searchData,updateCount])
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname==`/admin-panel/CheckProviderDetail/PermissionsDetail/${id}`? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Fund Subscribers</span>

    </div>


     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            {/* <div style={{width:"95%",padding:27}} className='ProviderTitle'>
                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                    <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                        <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Consumer Address</span>
                                    </div>
                                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                        <TextField style={{width:"100%"}} onChange={(e)=>{
                                          setsearchData(e.target.value)

                                        }} id="outlined-basic" label="Enter Consumer Address" variant="outlined" />
                                        <div >

                                        </div>
                                        </div>
                                </div>




                            </div> */}
                            <div style={{width:"98%",marginTop:40}}>
                                <ProviderDetailsTable data={data} setupdateCount={setupdateCount} updateCount={updateCount}/>
                            </div>

            </div>

</div>}
</>
  )
}

export default ProviderDataConsumer